import {Component, ElementRef, OnInit}   from '@angular/core'
import {Router, ActivatedRoute} from '@angular/router'
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import {AuthService, LocalizeService} from '../../insa-services'
import { appConfig } from '../../../insaweb.config'
import { TwoFactorService, TotpSetupResponse } from '../../insa-services/insa-twofactor.service';


export type SetupStep = 'idle' | 'loading' | 'scan' | 'confirming' | 'recovery' | 'done' | 'error';


// export interface TotpSetupResponse {
//   secret: string;
//   qrCodeImageBase64: string;
//   twoFactorEnabled?: boolean;
//   twoFactorSetupCompleted?: boolean;
// }

export interface EnableTwoFactorResponse {
  message: string;
  twoFactorEnabled: boolean;
  twoFactorSetupCompleted: boolean;
  recoveryCodes: string[];
  token: string;
  auth_stage: string;
  twoFactorRequired: boolean;
  SessionID?: string;
}

@Component({
  templateUrl: 'twoFactorSetup.component.html'
})
export class TwoFactorSetupComponent implements OnInit {
  step: SetupStep = 'idle';
  setupData: TotpSetupResponse | null = null;
  recoveryCodes: string[] = [];
  recoveryConfirmed = false;
  errorMessage = '';
  showManualKey = false;
  completedAuthToken: string | null = null;

  form: FormGroup;

  constructor(
    private fb: FormBuilder,
    private twoFactorService: TwoFactorService,
    private authService: AuthService,
    public router: Router
  ) {
    this.form = this.fb.group({
      code: [
        '',
        [
          Validators.required,
          Validators.pattern(/^\d{6}$/)
        ]
      ]
    });
  }

  ngOnInit(): void {
    if (!this.authService.hasPreTwoFactorState()) {
      this.router.navigate(['/login']);
      return;
    }

    this.startSetup();
  }

  startSetup(): void {
    this.step = 'loading';
    this.errorMessage = '';
    this.setupData = null;

    this.twoFactorService.setupTotp().subscribe({
      next: (data: TotpSetupResponse) => {
        this.setupData = data;
        console.log('TOTP setup data received:', this.setupData.QrCodeImageBase64);
        this.step = 'scan';
      },
      error: (err) => {
        this.errorMessage = err?.error?.message || 'Setup failed. Please try again.';
        this.step = 'error';
      }
    });
  }

  confirmSetup(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    this.step = 'confirming';
    this.errorMessage = '';

    this.twoFactorService.enableTotp(this.form.value.code).subscribe({
      next: (res: EnableTwoFactorResponse) => {
        this.recoveryCodes = res.recoveryCodes || [];
        this.completedAuthToken = res.token;
        this.step = 'recovery';
      },
      error: (err) => {
        this.errorMessage = err?.error?.message || 'Invalid code. Please try again.';
        this.step = 'scan';
        this.form.patchValue({ code: '' });
      }
    });
  }

  finishSetup(): void {
    if (!this.recoveryConfirmed) {
      return;
    }

    // const preToken = this.authService.getPreTwoFactorToken();

    // if (!preToken) {
    //   this.errorMessage = 'Your login session expired. Please sign in again.';
    //   this.step = 'error';
    //   return;
    // }

    if (!this.completedAuthToken) {
    this.errorMessage = 'Your login session expired. Please sign in again.';
    this.step = 'error';
    return;
  }

  this.authService.clearPreTwoFactorState();
  this.authService.performAuthenticaton(this.completedAuthToken);
  this.authService.emitLogedInStatusChange();
  this.step = 'done';
  // app.component handles navigation to /home via LoggedInStatusChangedEmitter
  }

  copyRecoveryCodes(): void {
    const text = this.recoveryCodes.join('\n');

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(text).catch(() => { });
    }
  }

  toggleManualKey(): void {
    this.showManualKey = !this.showManualKey;
  }

  reset(): void {
    this.step = 'idle';
    this.setupData = null;
    this.recoveryCodes = [];
    this.recoveryConfirmed = false;
    this.errorMessage = '';
    this.showManualKey = false;
    this.form.reset();
  }
}



// WEBPACK FOOTER //
// ./app/insa-components/insa-login/twoFactorSetup.component.ts